export const trackPageView = (url) => {
    if (window.gtag) {
      window.gtag('config', 'G-4WVC1NRM40', {
        page_path: url,
      });
    }
  };
  
  export const trackEvent = (action, category, label, value) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  };
  